// extracted by mini-css-extract-plugin
module.exports = {"navCard":"Z9F88BABeTiVf47ywtPF","icon":"vJeCbyvdU2MxUgaDxmHR"};